import React, { ReactNode } from 'react';

interface StepCardProps {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  className?: string;
}

const StepCard: React.FC<StepCardProps> = ({ title, icon, children, className = '' }) => {
  return (
    <div
      className={`bg-white dark:bg-slate-800 rounded-xl shadow-[0_1px_3px_0_rgb(0,0,0,0.1),0_1px_2px_-1px_rgb(0,0,0,0.1)] border border-slate-200 dark:border-slate-700 overflow-hidden transition-colors duration-200 ${className}`}
    >
      <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-slate-100 dark:border-slate-700 flex items-center space-x-2 sm:space-x-3">
        <div className="text-indigo-700 dark:text-indigo-400">{icon}</div>
        <h2 className="text-base sm:text-lg font-bold text-slate-900 dark:text-white">{title}</h2>
      </div>
      <div className="p-4 sm:p-6 text-slate-700 dark:text-slate-300">{children}</div>
    </div>
  );
};

export default StepCard;
